import React from 'react';
import Indicator from './indicator';

const UnitQualityIndicators = ({ Description, Indicators }) => {
  return (
    <div className="quality-indicators">
      {Description && <p>{Description}</p>}
      {Indicators?.map((indicator, index) => (
        <Indicator
          key={index}
          indicator={indicator}
        />
      ))}
    </div>
  );
};
export default UnitQualityIndicators;
